import { FC } from 'react';
import { AdminClientLayout } from 'pages/atoms';
import { ClientAdminsList } from 'containers/admin';

const AdminClientAdministratorsPage: FC = () => {
  return (
    <AdminClientLayout>
      <ClientAdminsList />
    </AdminClientLayout>
  );
};

export default AdminClientAdministratorsPage;
